import { render, staticRenderFns } from "./SFXAssemblyUpdate.vue?vue&type=template&id=f0d896c0&scoped=true&"
import script from "./SFXAssemblyUpdate.vue?vue&type=script&lang=js&"
export * from "./SFXAssemblyUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SFXAssemblyUpdate.vue?vue&type=style&index=0&id=f0d896c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d896c0",
  null
  
)

export default component.exports